import './polyfill'
import Dbtn from './modules/Dbtn';

window.addEventListener('DOMContentLoaded', function() {
  if(document.querySelector('.d-btn')) {
    new Dbtn();
  }
});
